import React, { useEffect } from "react";
import { RxCaretLeft, RxCaretRight } from "react-icons/rx";
import useBookingApp from "../../../../hooks/useBookingApp";

export default function AppointmentBFRightContent({
  mainColor,
  handleNextStep,
  handlePrevStep,
  activeStep,
  activeStepTitle,
  bookingFormSteps,
  setBookingFormSteps,
  setActiveStep,
  setActiveStepTitle,
  renderStepContentRight,
}) {
  const { bookingSectionState } = useBookingApp();
  const { companyDetails, isEnablePrePayment } = bookingSectionState;
  const isCurrentStepVisited = bookingFormSteps[activeStep]?.visited;

  useEffect(() => {
    const persistedStepperNavigation = JSON.parse(
      localStorage.getItem("stepper-navigation")
    );

    if (persistedStepperNavigation) {
      setBookingFormSteps(persistedStepperNavigation);
      localStorage.setItem("fromRefresh", "true");
    } else {
      localStorage.removeItem("fromRefresh");
    }
  }, []);

  return (
    <div className="inner-content">
      {activeStep !== 0 && activeStepTitle !== "Success" && (
        <>
          <div className="bf-header">
            <RxCaretLeft
              onClick={handlePrevStep}
              style={{
                cursor: activeStep > 0 ? "pointer" : "not-allowed",
                color: activeStep > 0 ? "inherit" : "lightgray",
              }}
            />
            {activeStepTitle && (
              <p className="section-title">{activeStepTitle}</p>
            )}
            <RxCaretRight
              onClick={isCurrentStepVisited ? handleNextStep : undefined}
              style={{
                cursor: isCurrentStepVisited ? "pointer" : "not-allowed",
                color: isCurrentStepVisited ? "inherit" : "lightgray",
              }}
            />
          </div>

          <div
            className="steps-container"
            style={{
              gridTemplateColumns: `repeat(${
                isEnablePrePayment ? "3" : "2"
              }, 1fr)`,
            }}
          >
            {bookingFormSteps
              .slice(1)

              .map((step, index) => (
                <div
                  key={index}
                  className="step-bar"
                  onClick={() => {
                    setActiveStep(index);
                    setActiveStepTitle(step);
                  }}
                  style={{
                    backgroundColor:
                      index <= activeStep - 1 ? mainColor : "lightgray",
                    transition: "background-color 0.3s ease",
                  }}
                ></div>
              ))}
          </div>
        </>
      )}

      <div className="step-content">{renderStepContentRight(activeStep)}</div>
    </div>
  );
}
